import { HttpClientNormal } from "@/services/entities/HttpClient.ts";
import { SearchResponse } from "@/services/entities/AxiosMethod.ts";
import { baseUrlApi, BuildURLWithTenantId } from "@/commons/RootURL.ts";
import { AxiosResponse } from "axios";
import { IOrgService } from "@/services/organization-service/IOrganizationService.ts";
import { OrganizationInfo } from "@/services/organization-service/entity/OrganizationEntity.ts";

export class OrgService implements IOrgService {
  private _httpClient: HttpClientNormal = new HttpClientNormal();

  getOrgList(endpoint: string): Promise<SearchResponse<OrganizationInfo>> {
    const url = `${BuildURLWithTenantId(baseUrlApi)}tenants${endpoint}`;
    return this._httpClient
      .get(url)
      .then((response: AxiosResponse) => {
        return new SearchResponse<OrganizationInfo>(response, OrganizationInfo);
      })
      .catch((err) => new SearchResponse<OrganizationInfo>(err?.response));
  }
}